import { Link } from "react-router-dom";

const COLUMNS = [
  {
    title: "内容导航",
    links: [
      { label: "电影", to: "/category/movie" },
      { label: "电视剧", to: "/category/tv" },
      { label: "影视资讯", to: "/category/news" },
      { label: "搜索", to: "/search" },
    ],
  },
  {
    title: "热门类型",
    links: [
      { label: "科幻片", to: "/category/movie" },
      { label: "悬疑片", to: "/category/movie" },
      { label: "古装剧", to: "/category/tv" },
      { label: "都市剧", to: "/category/tv" },
    ],
  },
  {
    title: "关于我们",
    links: [
      { label: "网站介绍", to: "/about" },
      { label: "使用条款", to: "/about" },
      { label: "联系方式", to: "/about" },
      { label: "版权声明", to: "/about" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="mt-16 bg-primary-950 text-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8">
        <div className="flex flex-col gap-10 lg:flex-row lg:justify-between">
          <div className="max-w-sm">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-primary-950">
                <i className="ri-plant-line text-lg"></i>
              </span>
              <span className="font-heading-role text-lg font-bold text-white">
                蘑菇<span className="text-accent-400">MOGU2</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-200">
              蘑菇MOGU2 是一个面向影视爱好者的内容聚合站点，汇集电影、电视剧资源与最新影视资讯，
              帮助你轻松找片、追剧并获取专业推荐。
            </p>
            <p className="mt-4 text-xs leading-relaxed text-background-300">
              本站内容与数据均为演示用途，影视信息仅作展示参考。
            </p>
          </div>

          <div className="grid grid-cols-1 gap-8 sm:grid-cols-3 lg:gap-14">
            {COLUMNS.map((column) => (
              <div key={column.title}>
                <h3 className="mb-4 text-sm font-semibold text-white">{column.title}</h3>
                <ul className="flex flex-col gap-2.5">
                  {column.links.map((link) => (
                    <li key={`${column.title}-${link.label}`}>
                      <Link
                        to={link.to}
                        className="cursor-pointer text-sm text-background-200 transition-colors hover:text-accent-400"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start gap-3 border-t border-primary-800 pt-6 text-xs text-background-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 蘑菇MOGU2 影视站 · 保留所有权利</p>
          <p>本站所有影视资料与资讯仅用于产品演示，不提供任何资源下载服务。</p>
        </div>
      </div>
    </footer>
  );
}